let Config = {
    G_EVENT_ID: '201912030311910', // 活动id
    G_EVENT_KEY: 'VlVdTElWVV9FS1VUVURI' // 活动id对应的加密串
};

// 对外提供接口
export default Config;
